export default "__VITE_ASSET__BWSzFgOv__"